import { EDashboardActions, DashboardActions } from "@edp-store/actions/dashboard.actions";
import { IDashboardState, initialDashboardState, initialDashboardResetState } from "@edp-store/state/dashboard.state";

export function dashboardReducers(state = initialDashboardState, action: DashboardActions): IDashboardState {
    switch (action.type) {
        case EDashboardActions.SetInvoices: {
            return {
                ...state,
                invoices: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.InvoicesAPIError: {
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.SetBalance: {
            return {
                ...state,
                balance: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.BalanceAPIError: {
            return {
                ...state,
                balance: {
                    ...state.balance,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.SetActiveMetersElectricity: {
            return {
                ...state,
                activeMetersElectricity: action.payload,
            };
        }
        case EDashboardActions.SetActiveMetersGas: {
            return {
                ...state,
                activeMetersGas: action.payload,
            };
        }
        case EDashboardActions.SetContractRequests: {
            return {
                ...state,
                contractRequest: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.ContractRequestsAPIError: {
            return {
                ...state,
                contractRequest: {
                    ...state.contractRequest,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.SetUploadReading: {
            return {
                ...state,
                uploadReading: action.reading,
            };
        }
        case EDashboardActions.SetSimulation: {
            return {
                ...state,
                simulation: action.payload,
            };
        }
        case EDashboardActions.SetFunciona: {
            return {
                ...state,
                funciona: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.FuncionaAPIError: {
            return {
                ...state,
                funciona: {
                    ...state.funciona,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.SetCampaigns: {
            return {
                ...state,
                campaigns: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.CampaignsAPIError: {
            return {
                ...state,
                campaigns: {
                    ...state.campaigns,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.ClearSelectedContractData: {
            return {
                ...state,
                ...initialDashboardResetState,
            };
        }
        case EDashboardActions.SetRecaptcha: {
            return {
                ...state,
                recaptcha: action.recaptcha,
            };
        }
        case EDashboardActions.SetRecaptchaResponse: {
            return {
                ...state,
                recaptchaResponse: action.recaptchaResponse,
            };
        }
        case EDashboardActions.SetBankList: {
            return {
                ...state,
                bankList: action.bankList,
            };
        }
        case EDashboardActions.SetMeterInstructions: {
            return {
                ...state,
                meterInstructions: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.MeterInstructionsAPIError: {
            return {
                ...state,
                meterInstructions: {
                    ...state.meterInstructions,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.SetElectricMobilityWidgetData: {
            return {
                ...state,
                electricMobility: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EDashboardActions.ElectricMobilityWidgetAPIError: {
            return {
                ...state,
                electricMobility: {
                    data: null,
                    lastAPIError: action.error,
                },
            };
        }
        case EDashboardActions.ShowNewLocalToastr: {
            return {
                ...state,
                showNewLocalToastr: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
